import { observable, action } from 'mobx';
class MenuData {
    @observable public menuList: newBackMenuType = {
        pubFolders:[],
        topFolders:[]
    };
    @action
    public setMenuList = (menuList: newBackMenuType) => {
        this.menuList = menuList
    }
}
export { MenuData }
export default new MenuData()